import { render, staticRenderFns } from "./FeedbackTable.vue?vue&type=template&id=31805159&scoped=true&"
import script from "./FeedbackTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackTable.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTable.vue?vue&type=style&index=0&id=31805159&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31805159",
  null
  
)

export default component.exports